import gql from "graphql-tag"

export const CREATE_MEANS_OF_VERIFICATION = gql`
  mutation createManyMeansOfVerification(
    $id: ID!
    $relationType: TypeEnum!
    $data: [CreateMeansOfVerificationInput!]!
  ) {
    createManyMeansOfVerification (
      id: $id
      data: $data
      relationType: { type: $relationType }
    ) {
      id
      verificationDocumentsPerMonth {
        id
      }
      activity {
        id
      }
      indicator {
        id
      }
    }
  }
`
